import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class LegacyService {

  private legacyInformationAll = 'legacy-info/all';

  constructor(private http: HttpClient) { }

  getLegacyInformationAll() {
    return this.http.get(this.legacyInformationAll,{withCredentials : true});
  }

}
